/* ColumnSettingsComponent.js */

'use strict';
const EventEmitter = require('events').EventEmitter;
const Renderer = require('./ColumnSettingsRenderer');

class ColumnSettingsComponent extends EventEmitter {
    constructor(logger) {
        super();
        this._logger = logger;

        this._enabled = false;
        this._toggled = false;

        this._renderer = new Renderer(this);
        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){
        this.on("UpdateColumnSettings", this._onUpdateColumnSettings = this._onUpdateColumnSettings.bind(this));
    }
    _unregisterListeners(){
        this.removeListener("UpdateColumnSettings", this._onUpdateColumnSettings);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    get logger(){
        return this._logger;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer.shutdown()
            .then(()=>{
                this._logger = undefined;
                this._toggled = undefined;
                this._enabled = undefined;
            }, (err)=>{
                this._logger.warn(err, 'GameEditorFilterComponent.shutdown error');
            });
    }
    setProperties(props){
        this.emit('FilterProperties', props);
    }

    get enabled(){
        return this.getEnabled();
    }
    set enabled(val){
        this.setEnabled(val);
    }
    getEnabled(){
        return this._enabled;
    }
    setEnabled(val){
        this._enabled = val;
        this.emit('EnabledStateChange', this._enabled);
    }

    get toggled(){
        return this.getToggled();
    }
    set toggled(val){
        this.setToggled(val);
    }
    getToggled(){
        return this._toggled;
    }
    setToggled(val){
        this._toggled = val;
        this.emit('ToggledStateChange', this._toggled);
    }

    get collapsed(){
        return this.getCollapsed();
    }
    set collapsed(val){
        this.setCollapsed(val);
    }
    getCollapsed(){
        return this._collapsed;
    }
    setCollapsed(val){
        this._collapsed = val;
        this.emit('Collapsed', this._collapsed);
    }

    get active(){
        return this._active;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onUpdateColumnSettings(columnSettings) {
        this._renderer._updateColumnSettings(columnSettings);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    columnSettingsUserChange(newColumnSettings){
        this.emit('ColumnSettingsChange', newColumnSettings);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ColumnSettingsComponent;